unit View.Sincronizacao_Aliados.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils;

type
  TFViewSincronizacao_AliadosList = class(TWebForm)
    btNew: TWebButton;
    Sincronizacao_AliadosDataset: TXDataWebDataSet;
    Sincronizacao_AliadosDatasetid: TIntegerField;
    Sincronizacao_AliadosDatasetaliado_id: TIntegerField;
    Sincronizacao_AliadosDatasetsincronizacao_service_id: TIntegerField;
    Sincronizacao_AliadosDatasetsincronizar_dados: TBooleanField;
    Sincronizacao_AliadosDatasetinclusao: TDateTimeField;
    Sincronizacao_AliadosDatasetalteracao: TDateTimeField;
    Sincronizacao_AliadosDatasetsincronizacao_service: TXDataWebEntityField;
    Sincronizacao_AliadosDatasetsincronizacao_servicetabela: TStringField;
    WebDBTableControl1: TWebDBTableControl;
    WebDataSource: TWebDataSource;
    cbPageSize: TWebComboBox;
    edSearch: TWebEdit;
    lbPaginationInfo: TWebLabel;
    lcPaginator: TWebListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TWebForm;
  end;

var
  FViewSincronizacao_AliadosList: TFViewSincronizacao_AliadosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewSincronizacao_AliadosList }

procedure TFViewSincronizacao_AliadosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewSincronizacao_AliadosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TWebForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewSincronizacao_AliadosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewSincronizacao_AliadosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewSincronizacao_AliadosList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewSincronizacao_AliadosList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewSincronizacao_AliadosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TWebButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Sincronizacao_AliadosDataset.Connection.Model.DefaultSchema.FindEntityType(Sincronizacao_AliadosDataset.EntitySetName),
      Sincronizacao_AliadosDataset.CurrentData
    );
    Button := TWebButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewSincronizacao_AliadosList.WebFormCreate(Sender: TObject);
begin
  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Sincronizacao_AliadosDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

end.
